module.exports = __webpack_public_path__ + "img/default.862dca9.png";